import styled from "styled-components";
import { FaGoogle } from "react-icons/fa";
import { SiMaildotru } from "react-icons/si";
import goTo from "../../../../controllers/goTo";
import loginWithGoogle from "../../../../controllers/auth/loginWithGoogle";
import { useState } from "react";
import LoadingSection from "../../../helperComponents/LoadingSection";

const PageWrapper = styled.div`
  font-family: "Inter", sans-serif;
  background: #ffffff;
  color: #000000;
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 900px) {
    padding: 25px;
    align-items: flex-start;
  }
`;

/* Navbar */
const Navbar = styled.nav`
  width: 85vw;
  padding: 0;
  margin-top: 60px;
  margin-bottom: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    height: 40px;
  }

  ul {
    display: flex;
    list-style: none;
    gap: 100px;

    li {
      cursor: pointer;
      font-size: 18px;
      font-weight: 600;
      color: #111;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

/* Hero Section */
const Hero = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* text-align: center; */
  margin: 2rem 1rem;
  position: relative;

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

/* Illustration */
const Illustration = styled.div`
  position: relative;
  margin: 2rem 0;

  .guy {
    width: 250px;
    max-width: 100%;
  }

  .butterfly {
    display: none;
  }

  &.flipped {
    display: none;
  }

  @media (min-width: 1024px) {
    .guy {
      width: 320px;
    }

    &.flipped {
      display: block;
    }

    &.flipped img.guy {
      /* display: no; */
      transform: scaleX(-1);
    }

    /* &.flipped img.guy {
      transform: scaleX(-1);
    }

    &.flipped img.butterfly {
      transform: scaleX(-1);
    } */

    &.flipped img.butterfly {
      transform: translateX(250px) scaleX(-1);
    }

    .butterfly {
      display: block;
      width: 50px;
    }
  }
`;

const CenterContent = styled.div`
  display: flex;
  flex-direction: column;

  position: relative;
  gap: 15px;
  align-items: flex-start;

  h1 {
    font-size: 30px;
    font-weight: 800;

    margin: 0 0;
    color: #000;

    span.orange {
      color: #f97316;
    }
  }

  p {
    margin: 0;
    padding: 0;
    font-size: 15px;
    font-weight: 500;
    color: #6b7280;
  }

  .btn-group {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.6rem;
      border: 2px solid #000;
      border-radius: 50px;
      padding: 1rem;
      font-size: 1rem;
      font-weight: 600;
      background: #fff;
      cursor: pointer;
      transition: 0.2s;
      width: calc(90vw - 50px);

      &:hover {
        background: #f9fafb;
      }

      svg {
        font-size: 1.3rem;
      }
    }
  }

  @media (min-width: 900px) {
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
    gap: 20px;
    /* margin-top: -100px; */

    h1 {
      width: 50vw;
      font-size: 45px;
      text-align: center;

      justify-content: center;
      align-items: center;
    }

    p {
      font-size: 18px;
      font-weight: 500;
    }

    .btn-group {
      margin-top: 30px;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      button {
        width: 300px;
      }
    }
  }
`;

const Dragonfly = styled.img`
  position: absolute;
  width: 100px;
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);

  @media (max-width: 768px) {
    display: none;
  }
`;

/* Info Section */
const InfoSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 0 0;
  margin-top: 50px;

  .infoBox {
    border: 1px solid #99999940;
    padding: 25px;
    /* max-width: 80vw; */
    margin: auto;
    width: 100%;
    display: flex;
    border-radius: 10px;
    flex-direction: row;
    gap: 15px;

    img {
      height: 60px;
      /* margin-bottom: 0.5rem; */
    }

    h3 {
      margin: 0;
      font-size: 1rem;
      font-weight: 700;
    }

    p {
      margin: 0;
      padding: 0;
      margin-top: 10px;
      font-size: 0.9rem;
      font-weight: 500;
      color: #4b5563;
    }
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-around;
    gap: 100px;
    margin-top: 120px;

    .infoBox {
      max-width: 25vw;
      text-align: left;
      margin: 0;
    }
  }
`;

const MobileLogo = styled.img`
  display: none;

  @media (max-width: 900px) {
    display: block;
    margin-bottom: 30px;
  }
`;

export default function LandingPage() {
  const [googleLoginLoading, setGoogleLoginLoading] = useState(false);

  if (googleLoginLoading)
    return (
      <PageWrapper>
        <LoadingSection />
      </PageWrapper>
    );

  return (
    <PageWrapper>
      {/* Navbar */}
      <Navbar>
        <ul>
          <li>Home</li>
          <li>About Us</li>
        </ul>
        <img src="/logo/full-logo.svg" alt="Karuna Logo" />
        <ul>
          <li>Contact Us</li>
          <li>FAQ</li>
        </ul>
      </Navbar>

      <Hero>
        <Illustration>
          <img
            className="guy"
            src="/vector-graphics/guy-with-a-bird.jpg"
            alt="Guy with bird"
          />
          <img
            className="butterfly"
            src="/vector-graphics/butterfly.jpg"
            alt="Butterfly"
          />
        </Illustration>

        <MobileLogo src="/logo/full-logo.svg" alt="Karuna Logo" />

        <CenterContent>
          <h1>
            Bringing <span className="orange">Companies, NGOs</span> &{" "}
            <span className="orange">Volunteers</span> Together
          </h1>
          <p>Your Platform for Collective Social Impact</p>

          <div className="btn-group">
            <button
              onClick={() => {
                loginWithGoogle(setGoogleLoginLoading);
              }}
            >
              <FaGoogle /> Continue With Google
            </button>
            <button onClick={goTo("/auth")}>
              <SiMaildotru /> Continue With Email
            </button>
          </div>
        </CenterContent>

        <Illustration className="flipped">
          <img
            className="guy"
            src="/vector-graphics/guy-with-a-bird.jpg"
            alt="Guy with bird"
          />
          <img
            className="butterfly"
            src="/vector-graphics/butterfly.jpg"
            alt="Butterfly"
          />
        </Illustration>

        <Dragonfly src="/vector-graphics/dragonfly.jpg" alt="Dragonfly" />
      </Hero>

      <InfoSection>
        <div className="infoBox">
          <img src="/vector-graphics/empowers-ngo.jpg" alt="Empowers NGOs" />

          <div className="infoText">
            <h3>Empowers NGOs</h3>
            <p>
              Easily connect with companies offering CSR funds and volunteers
              who align with your cause.
            </p>
          </div>
        </div>

        <div className="infoBox">
          <img
            src="/vector-graphics/empowers-volunteers.jpg"
            alt="Empowers Volunteers"
          />

          <div className="infoText">
            <h3>Empowers Volunteers</h3>
            <p>
              Whether it's education, environment, or health — Setu matches you
              with NGOs and projects aligned with your passion and availability.
            </p>
          </div>
        </div>

        <div className="infoBox">
          <img
            src="/vector-graphics/empowers-companies.jpg"
            alt="Empowers Companies"
          />

          <div className="infoText">
            <h3>Empowers Companies</h3>
            <p>
              Setu connects your company with trusted, impact-driven NGOs so you
              can support initiatives that align with your brand values and
              compliance needs.
            </p>
          </div>
        </div>
      </InfoSection>
    </PageWrapper>
  );
}
